import * as yup from 'yup';
import { streetAddressLineOneValidationSchema, streetAddressLineTwoValidationSchema, zipCodeValidationSchema, cityValidationSchema, stateValidationSchema } from "../../../../AddressFields";

export const validationSchema = yup.object({
    individualName: yup.string().required("Please enter the name of the entity/individual"),
    businessName: yup.string().optional(),
    llcType: yup.string().when("taxClassification", {
        is: (value) => value === "Limited Liability Company (LLC)",
        then: (schema) => schema.required("Please choose an LLC type"),
    }),
    payeeName: yup.string().optional(),
    taxClassification: yup.string().required("Please select your federal tax classification"),
    otherTaxClass: yup.string().when("taxClassification", {
        is: (value) => value === "Other",
        then: (schema) => schema.required("Please enter your tax classification"),
    }),
    exemptCode: yup.string().optional(),
    fatcaCode: yup.string().optional(),
    addressLine1: yup.string().when(["w9AddressSameAsAgencyPrimaryPhysical", "w9AddressSameAsAgencyPrimaryMailing"], {
        is: (agencyPrimary, principalPrimary) => !agencyPrimary && !principalPrimary,
        then: (schema) => streetAddressLineOneValidationSchema,
        otherwise: (schema) => schema.optional()
    }),
    addressLine2: streetAddressLineTwoValidationSchema,
    city: yup.string().when(["w9AddressSameAsAgencyPrimaryPhysical", "w9AddressSameAsAgencyPrimaryMailing"], {
        is: (agencyPrimary, principalPrimary) => !agencyPrimary && !principalPrimary,
        then: (schema) => cityValidationSchema,
        otherwise: (schema) => schema.optional()
    }),
    state: yup.string().when(["w9AddressSameAsAgencyPrimaryPhysical", "w9AddressSameAsAgencyPrimaryMailing"], {
        is: (agencyPrimary, principalPrimary) => !agencyPrimary && !principalPrimary,
        then: (schema) => stateValidationSchema,
        otherwise: (schema) => schema.optional()
    }),
    zipCode: yup.string().when(["w9AddressSameAsAgencyPrimaryPhysical", "w9AddressSameAsAgencyPrimaryMailing"], {
        is: (agencyPrimary, principalPrimary) => !agencyPrimary && !principalPrimary,
        then: schema => zipCodeValidationSchema,
        otherwise: (schema) => schema.optional()
    }),
    accountNumbers: yup.string().optional().max(50, "Account number is too long"),
    ssn: yup.string()
        .transform((value) => value ? value.replace(/-/g, '') : value)
        .test("length", "Please enter a valid SSN", value => !value || value?.length === 0 || value?.length === 9),
    fein: yup.string()
        .transform((value) => value ? value.replace(/-/g, '') : value)
        .test("length", "Please enter a valid FEIN", value => !value || value?.length === 0 || value?.length === 9),
    taxId: yup.string().when(["ssn", "fein"], {
        is: (ssn, fein) => ((!ssn || ssn === "") && (!fein || fein === "")),
        then: schema => schema.nonNullable().required("Please enter either SSN or FEIN")
    })
});
